import { render, staticRenderFns } from "./LocalDetalhes.vue?vue&type=template&id=5d0393e0&scoped=true&"
import script from "./LocalDetalhes.vue?vue&type=script&lang=js&"
export * from "./LocalDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0393e0",
  null
  
)

export default component.exports